import * as stateManagement from '#packages/stateManagement';
import {
  WorkspaceRightPanelApiKey,
  FixedStageApiKey,
  EditorRestrictionsApiKey,
} from '#packages/apis';

import type { EditorAPI } from '#packages/editorAPI';
import type { MapStateToProps, Dispatch, StateMapperArgs } from 'types/redux';
import type { EditorState } from '#packages/stateManagement';

import { fixedStage } from '#packages/util';

const { selectors, actions } = stateManagement.editorSearch;
const TOP_BAR_SEARCH_ORIGIN = 'topbar_search';

const shouldShowSearchComponent = ({ editorAPI }: StateMapperArgs) => {
  const restrictionsAPI = editorAPI.host.getAPI(EditorRestrictionsApiKey);
  return restrictionsAPI.allowed('top-bar_search.visible');
};

const mapStateToProps: MapStateToProps = ({ state, editorAPI }) => {
  const restrictionsAPI = editorAPI.host.getAPI(EditorRestrictionsApiKey);
  const disabled = !restrictionsAPI.allowed('top-bar_search.interactive');

  return {
    disabled,
    toggled: selectors.isPanelOpen(state),
    isSitePublished: editorAPI.dsRead?.generalInfo.isSitePublished(),
    isLabelShown: !editorAPI.host.getAPI(FixedStageApiKey).isTopBarMinimized(),
    topBarStateBIParamValue: fixedStage.getTopBarStateBiParamValue(editorAPI),
  };
};

const getEditorAPI = (
  dispatch: Dispatch,
  getState: () => EditorState,
  { editorAPI }: { editorAPI: EditorAPI },
): EditorAPI => editorAPI;
const mapDispatchToProps = (dispatch: Dispatch) => {
  const editorAPI = dispatch(getEditorAPI);
  return {
    openSearchPanel() {
      const workspaceRightPanelAPI = editorAPI.host.getAPI(
        WorkspaceRightPanelApiKey,
      );
      if (workspaceRightPanelAPI.isOpen()) {
        workspaceRightPanelAPI.close(TOP_BAR_SEARCH_ORIGIN);
      }
      dispatch(actions.openEditorSearchPanel({ origin: 'top_bar' }));
    },
  };
};

export { mapDispatchToProps, mapStateToProps, shouldShowSearchComponent };
